import {z} from 'zod';

/**
 * Schema for storage upload response
 */
export const storageUploadResponseSchema = z.object({
  fileId: z.string(),
  namespace: z.string(),
  status: z.enum(['uploaded', 'pending', 'failed']),
  analysisId: z.string().optional(),
});

export type StorageUploadResponse = z.infer<typeof storageUploadResponseSchema>;
